import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";
// get safety data

export const getSafetyData=createAsyncThunk("safetyData/get-SafetyData",async(data)=>{
    const token=localStorage.getItem('authToken')
    try{
        const response=await axios.post(`${baseUrl}cleaningappfunctions/operations/app/v1/get-SafetyData `,data,{
            headers:{
                "auth-token":token,
            }
        },);
        console.log({response})
        return response;
    }
    catch(error){
        console.log("Error fetching in safety data-",error);
        throw error;
    }
})